import { render, staticRenderFns } from "./TrashedUsersTableList.vue?vue&type=template&id=c3b62054"
import script from "./TrashedUsersTableList.vue?vue&type=script&lang=js"
export * from "./TrashedUsersTableList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports